var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"20px"}},[_vm._v(_vm._s(_vm.$t("barcode.wel").format(this.brandConfig.display)))]),_c('img',{staticStyle:{"width":"100%"},attrs:{"id":"barcode"}}),_c('p',{staticStyle:{"width":"100%","margin":"0","text-align":"center"}},[_vm._v(_vm._s(`eForm ID - ${this.custId}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }